import styled from 'styled-components';
import { size } from '../../layout/helpers';

export const Logo = styled.div`
  flex-shrink: 0;
  width: 155px;

  ${(props) => props.theme.breakpoint.LtMd} {
    order: 10;
    padding-top: ${size(3)};
    margin-top: 0;
    padding-top: 0;
    max-width: 130px;
  }

  ${(props) => props.theme.breakpoint.Md} {
    margin-right: ${size(9)};
  }
`;

export const LogoImg = styled.img`
  display: block;
  width: 100%;
`;
